// extracted by mini-css-extract-plugin
export default {"sideTitle":"side_details-module___sideTitle___bb72b37f","chatSection":"side_details-module___chatSection___b98955ad"};